import { createAction } from '@ngrx/store';

/**
 * Actions dispatched to retrieve recommended products
 */
export const getWeightManagementRecommendation = createAction('[Weight Management] Get Recommendation');

/**
 * Action dispatched to set selected dry and wet product from last consultation recommendation
 * OR redirect to product recommendation if products not found
 */
export const getFollowUpProductsAndSetNextStep = createAction('[Weight Management] Get Follow Up Products And Set Next Step');
